import { Component } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { HttpErrorResponse } from '@angular/common/http'
import { CallerService } from '../services/caller.service'

type ForgotPasswordStatus = 'form' | 'sent'

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent {
    status: ForgotPasswordStatus = 'form'
    isSubmitting: boolean = false

    email = new FormControl('', [Validators.required, Validators.email])

    constructor(private callerService: CallerService) {}

    submit(): void {
        if (this.email.invalid) {
            return
        }

        this.isSubmitting = true

        this.callerService.forgotPassword(this.email.value ?? '').subscribe({
            next: () => {
                this.isSubmitting = false
                this.status = 'sent'
            },
            error: (err: HttpErrorResponse) => {
                this.isSubmitting = false
                this.callerService.showNotification(
                    err?.error?.message ?? 'Something went wrong. Please try again.',
                    4000,
                    'Close',
                )
            },
        })
    }
}
